var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 8.81932C6.7609 8.97392 6.87297 9.12026 7.00264 9.25519C7.80764 10.093 9.03464 10.224 9.97157 9.64812C10.1452 9.54139 10.3088 9.41046 10.458 9.25519L12.6176 7.00759C13.5717 6.01455 13.5717 4.4045 12.6176 3.41144C11.6634 2.41839 10.1164 2.4184 9.16217 3.41144L8.6865 3.90651",
    stroke: "#097BED",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.31337 12.0933L6.83751 12.5885C5.88335 13.5816 4.33631 13.5816 3.38214 12.5885C2.42796 11.5955 2.42796 9.98546 3.38214 8.9924L5.54175 6.7448C6.49593 5.75174 8.04297 5.75173 8.99711 6.7448C9.12677 6.87966 9.23877 7.026 9.33317 7.18053",
    stroke: "#097BED",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link_icon.8ea92ded72d2cf409642153ace7e3277.svg";
export { ForwardRef as ReactComponent };